import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import "./style.css";
import Navbar from "../../Components/Navbar/index.tsx";
import contact from "../../Assets/Contact/contact.png";
import location from "../../Assets/Contact/location.png";
import mail from "../../Assets/Contact/mail.png";
import time from "../../Assets/Contact/time.png";
import Footer from "../../Components/Footer/index.tsx";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    mobile: "",
    reason: "",
    contactType: "",
    companyName: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
  
    const { name, email, mobile, reason, contactType } = formData;

    // Check if any required field is empty
    if (!name || !email || !mobile  ||!reason ||!contactType) {
      alert("Please fill out all required fields before submitting.");
      return;
    }
  
    // Log th
    const templateParams = {
      name: formData.name || "", // Make sure the name is not undefined
      email: formData.email || "", // Make sure the email is not undefined
      subject: formData.subject || "", // Subject might be empty
      mobile: formData.mobile || "", // Make sure the mobile is not undefined
      reason: formData.reason || "", // Optional, but always send
      contactType: formData.contactType || "", // Optional, but always send
      companyName: formData.contactType === "company" ? formData.companyName : "", 
      message: formData.message || "", // Message field should not be empty
    };
  
    // Log templateParams to make sure we are sending the right data
    // console.log("Template parameters:", templateParams);
  
    // Send email via emailjs
    emailjs
      .send(
        "service_7n9sofe",        // Your EmailJS Service ID
        "template_qmgee0t",       // Your EmailJS Template ID
        templateParams,           // The validated/formatted data
        "mEQV8ZfDnmzeWrxsh"       // Your EmailJS Public Key (user ID)
      )
      .then(
        (result) => {
          // console.log("Email sent successfully:", result.text);
          alert("Message sent successfully!");
          setFormData({
            name: "",
            email: "",
            subject:  formData.subject || "",
            mobile: "",
            reason: "",
            contactType: "",
            companyName: formData.contactType === "company" ? formData.companyName : "", 
            message: formData.message || "",
          });
        },
        (error) => {
          // console.error("Email sending error:", error.text);
          // console.error("Form data sent:", templateParams); // Log form data to debug
          alert("Something went wrong. Please try again.");
        }
      );
  };
  
  

  return (
    <>
      <Navbar />
      <div className="svg-image" style={{ marginBottom: "-10%" }}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <path
            fill="#005791"
            fillOpacity="1"
            d="M0,160L48,149.3C96,139,192,117,288,112C384,107,480,117,576,133.3C672,149,768,171,864,202.7C960,235,1056,277,1152,282.7C1248,288,1344,256,1392,240L1440,224L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"
          ></path>
        </svg>
      </div>

      <div className="contact-container">
        <h3 className="contact-hea">Contact Us</h3>
        <div className="contact-us-main">
          {/* Form Section */}
          <div className="form-container">
            <form >
              <div className="form-group">
                <label htmlFor="name">Name <span style={{ color: "red" }}>*</span></label>
                <input
                  className=" contact-input"
                  name="name"
                  id="name"
                  value={formData.name}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email <span style={{ color: "red" }}>*</span></label>
                <input
                  className=" contact-input"
                  type="email"
                  name="email"
                  id="email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label htmlFor="subject">Subject</label>
                <input
                  className="  contact-input"
                  name="subject"
                  id="subject"
                  value={formData.subject}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label htmlFor="mobile">Mobile <span style={{ color: "red" }}>*</span></label>
                <input
                  className="  contact-input"
                  type="tel"
                  name="mobile"
                  id="mobile"
                  value={formData.mobile}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label htmlFor="reason">Reason for Contact <span style={{ color: "red" }}>*</span></label>
                <input
                  className="contact-input"
                  type="text"
                  name="reason"
                  id="reason"
                  value={formData.reason}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label>You are a <span style={{ color: "red" }}>*</span></label>
                <br />
                <br />
                <label>
                  <input
                    type="radio"
                    name="contactType"
                    value="individual"
                    checked={formData.contactType === "individual"}
                    onChange={handleChange}
                    style={{ marginRight: "5px" }}
                  />
                  Individual
                </label>

                <label style={{ marginLeft: "20px" }}>
                  <input
                    type="radio"
                    name="contactType"
                    value="company"
                    checked={formData.contactType === "company"}
                    onChange={handleChange}
                    style={{ marginRight: "5px" }}
                  />
                  Company
                </label>
              </div>

              {formData.contactType === "company" && (
                <div className="form-group">
                  <label htmlFor="companyName">Company Name <span style={{ color: "red" }}>*</span></label>
                  <input
                    className="contact-input" 
                    name="companyName"
                    id="companyName"
                    value={formData.companyName}
                    onChange={handleChange}
                    required={formData.contactType === "company"}
                  />
                </div>
              )}

              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea
                  className="contact-input"
                  name="message"
                  id="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </div>

              <div>
                <div onClick={()=>handleSubmit()} className="contact-submit">
                  <div className="svg-wrapper-1">
                    <div className="svg-wrapper">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width="24"
                        height="24"
                      >
                        <path fill="none" d="M0 0h24v24H0z"></path>
                        <path
                          fill="currentColor"
                          d="M1.946 9.315c-.522-.174-.527-.455.01-.634l19.087-6.362c.529-.176.832.12.684.638l-5.454 19.086c-.15.529-.455.547-.679.045L12 14l6-8-8 6-8.054-2.685z"
                        ></path>
                      </svg>
                    </div>
                  </div>
                  <span>Submit</span>
                </div>
              </div>
            </form>
          </div>

          {/* Additional Content Section */}
          <div className="additional-content">
            <div className="icon-block">
              <div className="icon-wrapper-contact">
                <img src={location} alt="location" />
              </div>
              <div className="icon-text">
                <h4>LOCATION</h4>
                <p>8 Burn Road #15-14 Trivex 369977</p>
              </div>
            </div>
            <div className="icon-block">
              <div className="icon-wrapper-contact">
                <img src={contact} alt="contact-us" />
              </div>
              <div className="icon-text">
                <h4>PHONE</h4>
                <p>+65 8215 0399</p>
              </div>
            </div>
            <div className="icon-block">
              <div className="icon-wrapper-contact">
                <img src={mail} alt="email" />
              </div>
              <div className="icon-text">
                <h4>EMAIL</h4>
                <p>hr@singaporesecurityforce.com</p>
              </div>
            </div>
            <div className="icon-block">
              <div className="icon-wrapper-contact">
                <img src={time} alt="working hours" />
              </div>
              <div className="icon-text">
                <h4>WORKING HOURS</h4>
                <p>Available 24/7</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default ContactForm;
